"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));
var _async = _interopRequireDefault(require("react-select/async"));
var _react2 = require("@chakra-ui/react");
var _xCircle = _interopRequireDefault(require("@spothero/icons/x-circle"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AutoSuggestSelect = /*#__PURE__*/(0, _react.forwardRef)(({
  id,
  label,
  helperText,
  errorMessage,
  isInvalid,
  isDisabled,
  isRequired,
  getOptions,
  onChange,
  iconSrc,
  placeholder
}, ref) => {
  const {
    colors,
    fontSizes,
    sizes
  } = (0, _react2.useTheme)();
  const handleChange = selectedOption => {
    onChange(selectedOption);
  };
  const icon = (color = 'transparent') => ({
    alignItems: 'center',
    display: 'flex',
    ':before': {
      backgroundColor: color,
      content: '" "',
      display: 'block',
      marginRight: sizes['3'],
      height: sizes['4'],
      width: sizes['5'],
      mask: `url(${iconSrc}) no-repeat 50% 50%`,
      maskSize: 'contain'
    }
  });
  const baseText = {
    fontSize: fontSizes.base,
    color: colors.black
  };

  /** React Select doesn't use Chakra but it does use Emotion so it's not too difficult to use values from our Chakra theme. Here is the documentation for React Select styling: https://react-select.com/styles  */
  const customStyles = {
    menu: provided => ({
      ...provided,
      ...baseText
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200'],
      borderWidth: '1px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200']
      }
    }),
    input: (provided, state) => ({
      ...provided,
      ...baseText,
      padding: sizes['2'],
      backgroundColor: state.isDisabled ? colors.gray['200'] : 'transparent',
      ...(iconSrc && icon(colors.gray['600']))
    }),
    placeholder: provided => ({
      ...provided,
      padding: sizes['2'],
      fontSize: fontSizes.base,
      color: colors.gray['600'],
      ...(iconSrc && icon())
    }),
    singleValue: provided => ({
      ...provided,
      ...baseText,
      padding: sizes['2'],
      ...(iconSrc && icon())
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? colors.gray['200'] : state.isFocused ? colors.gray['50'] : 'transparent',
      color: colors.black
    }),
    clearIndicator: provided => ({
      ...provided,
      color: colors.gray['600']
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: colors.gray['600']
    })
  };
  const clearIndicatorStyles = {
    width: sizes['5'],
    display: 'flex',
    marginRight: sizes['3'],
    color: colors.gray['600'],
    cursor: 'pointer'
  };

  /** React Select allows you to override the clear indicator with your own custom component: https://react-select.com/components */
  const ClearIndicator = ({
    innerRef,
    innerProps
  }) => /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    style: clearIndicatorStyles,
    ref: innerRef
  }, innerProps), /*#__PURE__*/_react.default.createElement(_xCircle.default, null));
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/_react.default.createElement(_async.default, {
    closeMenuOnSelect: true,
    isClearable: true,
    cacheOptions: true,
    components: {
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
      ClearIndicator
    },
    openMenuOnClick: false,
    loadOptions: getOptions,
    onChange: handleChange,
    isDisabled: isDisabled,
    id: id,
    placeholder: placeholder,
    styles: customStyles,
    ref: ref
  }));
});
var _default = exports.default = AutoSuggestSelect;